/* eslint-disable import/first */
import '../config';
import React from 'react';
import { getErrorMsg } from '_common_old/utils/util';
import Cookies from 'js-cookie';
import { createRoot } from 'react-dom/client';
import { Message } from '@ok/okd';
import { LocaleProvider } from '@ok/react-locale';

import Routes from './routes';

const lang = Cookies.get('locale').toLowerCase();
import(`../locale/${lang}`)
  .then((data) => {
    const { default: localeData } = data;
    const root = createRoot(document.getElementById('root'));
    const view = (
      <LocaleProvider localeData={localeData}>{Routes}</LocaleProvider>
    );
    root.render(view);
  })
  .catch((error) => {
    const errorMsg = getErrorMsg(error);
    Message.error({
      title: errorMsg,
    });
  });
